import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';

class ClientLocationsForm extends React.Component {

  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
        />
        <small className="help-block">{help}</small>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

 
  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      isLoading,
    } = this.props;
    
    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Location Information</legend>
          <Field
            className="form-control"
            name="siteName"
            component={this.renderField}
            type="text"
            label="Location Name"
          />
          <Field
            className="form-control"
            name="clientLocationId"
            component={this.renderField}
            type="text"
            label="Client Location Id"
            disabled={true}
            maxLength={5}
          />
          <Field
            className="form-control"
            name="siteCode"
            component={this.renderField}
            type="text"
            label="Location Code"
            help="Location Code is used for reporting and should not include spaces or special characters - it is commonly the Hint Location ID as loc-XXXXXXXXX."
          />
          <Field
            className="form-control"
            name="practiceGroupName"
            component={this.renderField}
            type="text"
            label="Practice Group Name"
          />
          <Field
            className="form-control"
            name="siteDescription"
            component={this.renderField}
            type="text"
            label="Location Description"
            help="Brief summary of location. E.g., Onsite Health Center for ACME Corp HQ with Primary Care & Occ Health."
          />

          <Field
            className="form-control"
            name="latitude"
            component={this.renderField}
            type="text"
            label="Latitude"
          />
          <Field
            className="form-control"
            name="longitude"
            component={this.renderField}
            type="text"
            label="Longitude"
          />
        </fieldset>
        <fieldset>
          <legend>Address</legend>
          <Field
            className="form-control"
            name="address1"
            component={this.renderField}
            type="text"
            label="Address 1"
          />
          <Field
            className="form-control"
            name="address2"
            component={this.renderField}
            type="text"
            label="Address 2"
          />
          <Field
            className="form-control"
            name="city"
            component={this.renderField}
            type="text"
            label="City"
          />
          <Field
            className="form-control"
            name="state"
            component={this.renderField}
            type="text"
            label="State"
            maxLength={2}
          />
          <Field
            className="form-control"
            name="zip"
            component={this.renderField}
            type="text"
            label="Zip"
            maxLength={5}
          />
          <Field
            className="form-control"
            name="completeAddress"
            component={this.renderField}
            type="text"
            label="Complete Address"
            readOnly={true}
          />
          <Field
            className="form-control"
            name="phoneNumber"
            component={this.renderField}
            type="text"
            label="Phone Number"
          />
        </fieldset>
        
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="cover">
            <div className="spinner inline" />
          </div>
        )}
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  const required = [
    'siteName',
    'clientLocationId',
    'siteCode',
    'practiceGroupName',
    'siteDescription',
    'latitude',
    'longitude'
  ];
  
  required.forEach(el => {
    if (!values[el]) {
      errors[el] = 'Required';
    }
  });
  
  return errors;
};

ClientLocationsForm = connect(state => ({
  formValues: getFormValues('clientLocation')(state),
  initialValues: state.clientlocationmanager.clientLocation,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'clientLocation' })(ClientLocationsForm));
export default ClientLocationsForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/ClientLocationsForm.js